import { isPersistableModelProvider, type ChatModel, type ChatModelStatus } from '@reflex/shared';

/**
 * The model a task uses when no assignment row exists yet. A service-managed
 * provider (e.g. Runloop's deployment credential) is what the server actually
 * falls back to for unconfigured tasks, so when one reports a usable key it
 * wins over the static Anthropic default.
 */
export function findServiceManagedTaskModel(
  statuses: ChatModelStatus[] | undefined,
): ChatModel | null {
  const match = statuses?.find((s) => s.hasKey && !isPersistableModelProvider(s.provider));
  return match?.id ?? null;
}
